import { mmLog } from 'plugins/mm/constants';

export const baseLog = mmLog.extend('orderNotifications');
export const INSTORE_PAYMENT_REQUIRED = 'Instore_Payment_Required';
export const CURBSIDE_PAYMENT_REQUIRED = 'Curbside_Payment_Required';
